export default "__VITE_ASSET__NapFqpxm__"